var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"width":"3.25rem","height":"2.60rem"},attrs:{"id":"centreRight2Chart1"}},[_vm._v("123")])])}]

export { render, staticRenderFns }